import { ZfBox, ZfLoadingSpinner, ZfStack, ZfTab, ZfTabList, ZfTextButton, ZfTooltip, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { useApplicationVersion, useDownloadDbExport } from '../../api';
import { LanguageSwitch } from './LanguageSwitch';
import { RoleSwitch } from './RoleSwitch';

const contentAdminTabs: { label: string; value: string }[] = [
    { label: 'contentAdmin.navItemTopics', value: '/content-admin/topics' },
    { label: 'contentAdmin.navItemTalkingPoints', value: '/content-admin/talking-points' },
    { label: 'contentAdmin.navItemAdvisoryNeeds', value: '/content-admin/advisory-needs' },
    { label: 'contentAdmin.navItemDocuments', value: '/content-admin/documents' },
    { label: 'contentAdmin.navItemTools', value: '/content-admin/tools' },
    { label: 'contentAdmin.navItemDomiciles', value: '/content-admin/domiciles' },
];

export const ContentAdminToolbar: FunctionComponent = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { data: version } = useApplicationVersion();

    const activeTab = useMemo(() => {
        const isBasePath = contentAdminTabs.some(({ value }) => value === pathname);
        const extractedBasePath = pathname.substring(0, pathname.lastIndexOf('/'));

        return isBasePath ? pathname : extractedBasePath;
    }, [pathname]);

    const { mutate: downloadDbExport, isPending: isDownloadingDbExport } = useDownloadDbExport();

    return (
        <ZfBox className="app-content-admin-toolbar">
            <ZfStack direction="column">
                <ZfBox style={{ display: 'flex' }}>
                    <ZfTooltip text={version ? `Version: ${version}` : ''} side="right">
                        <ZfTypography slot="anchor" variant="heading-small" weight="bold" style={{ color: 'var(--fg-color-brand-normal)' }}>
                            {t('appTitle')}
                        </ZfTypography>
                    </ZfTooltip>
                </ZfBox>
                <ZfTabList value={activeTab} onTabChange={(e) => navigate(e.detail)}>
                    {contentAdminTabs.map(({ label, value }) => (
                        <ZfTab key={value} size="large" label={t(label)} value={value} />
                    ))}
                </ZfTabList>
            </ZfStack>
            <ZfStack direction="row" alignment="center">
                <ZfTextButton
                    hierarchy="secondary"
                    size="medium"
                    onClick={() => downloadDbExport()}
                    leadingIcon="download"
                    style={{ marginRight: 'var(--padding-right-md)' }}
                >
                    {t('dbExportDownloadButton')}
                    {isDownloadingDbExport ? <ZfLoadingSpinner size="small" /> : null}
                </ZfTextButton>
                <LanguageSwitch />
                <RoleSwitch />
            </ZfStack>
        </ZfBox>
    );
};
